export const UPLOADING_VIDEO = "Uploading video...";
export const UPLOADING_IMAGE = "Uploading image...";
export const UPLOADING_GIF = "Uploading gif...";
export const UPLOADING_PDF = "Uploading pdf...";



// WEBPACK FOOTER //
// ./src/Constants/string.js